import { Routes } from '@angular/router';
import { AuthGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'home' },

  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./features/auth/login/forgot/forgot.component').then(m => m.ForgotComponent),
  },

  {
    path: '',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./shared/ui/app-shell/app-shell.component').then(m => m.AppShellComponent),
    children: [
      {
        path: 'home',
        loadComponent: () => import('./features/home/home.component').then(m => m.HomeComponent),
      },
      {
        path: 'users',
        loadComponent: () => import('./features/users/users.page').then(m => m.UsersPage),
      },
      {
        path: 'smart-units',
        loadChildren: () =>
          import('./features/smart-units/smart-units.routes')
            .then(m => m.SMART_UNITS_ROUTES),
      },

      {
        path: 'pop-diagnostico',
        loadComponent: () => import('./features/pop-diagnostico/pop-diagnostico.page').then(m => m.PopDiagnosticoPage),
      },
    ],
  },

  {
    path: 'not-found',
    loadComponent: () => import('./shared/ui/not-found/not-found.component').then(m => m.NotFoundComponent),
  },
  { path: '**', redirectTo: 'not-found' },
];
